import React, { Component } from "react"
import { connect } from "react-redux"
import _ from "underscore"
import { Modal, ModalBody } from "../modals/Modal"
import "../../styles/_verify_candidate_modal.scss"
import "../../styles/_resume_listing_container.scss"
import $ from "jquery"
import { updateLogo, deleteCompanyLogo } from "../../actions/actions"
import ImageEditor from "./ImageEditor"
import { notify } from "../../services/helpers"

class ImageUploader extends Component {
  constructor(props) {
    super(props)
    const { imageData } = props
    this.state = {
      cropperOpen: false,
      img: null,
      croppedImg: imageData.url,
      showDeleteModal: false,
    }
    this.handleFileChange = this.handleFileChange.bind(this)
    this.handleCrop = this.handleCrop.bind(this)
    this.handleRequestHide = this.handleRequestHide.bind(this)
    this.handleFile = this.handleFile.bind(this)
    this.uploadImage = this.uploadImage.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  handleFileChange(dataURI) {
    this.setState({
      img: dataURI,
      croppedImg: this.state.croppedImg,
      cropperOpen: true,
    })
  }

  handleCrop(dataURI, blob) {
    this.setState({
      cropperOpen: false,
      img: null,
      croppedImg: dataURI,
    })
    this.uploadImage(blob)
  }

  handleRequestHide() {
    this.setState({
      cropperOpen: false,
    })
    this.formPhoto.value = ""
  }

  handleClick(e) {
    const { imageData } = this.props
    const { uploading, url } = imageData
    if (!uploading) {
      $(this.formPhoto).trigger("click")
    }
    e.preventDefault()
  }

  handleFile(e) {
    var reader = new FileReader()
    var file = e.target.files[0]
    if (!file) return
    let pictureName = null,
      pictureSize = null,
      pictureType = null

    if (file) {
      pictureName = file.name
      pictureSize = file.size
      pictureType = file.type
    }
    if (pictureSize) {
      if (pictureSize > 200000) {
        notify(
          "Failed to upload logo. Please upload a logo file having size less than 200 KB.",
          "error"
        )
        this.formPhoto.value = ""
        return
      }
    }
    const fileTypes = ["image/png", "image/jpeg", "image/jpg", "image/bmp"]
    if (fileTypes.indexOf(pictureType) === -1) {
      notify("The file type is not supported. Please choose an image.", "error")
      this.formPhoto.value = ""
      return
    }
    reader.onload = function (img) {
      this.handleFileChange(img.target.result)
    }.bind(this)
    reader.readAsDataURL(file)
  }

  uploadImage(dataURI) {
    const { updateLogo, resumeId, company, authToken } = this.props
    updateLogo(
      {
        "logo-file": dataURI,
        id: resumeId,
        field: "company",
        "field-entity": company,
        session_token: authToken,
      },
      this.formPhoto,
      company
    )
    this.formPhoto.value = ""
  }

  closeDeleteModal() {
    this.setState({ showDeleteModal: false })
  }

  deleteLogo(company) {
    const { deleteCompanyLogo, resumeId } = this.props
    deleteCompanyLogo(resumeId, company)
    this.closeDeleteModal()
  }

  render() {
    const { imageData, company } = this.props
    const { showDeleteModal } = this.state
    const { uploading, url, type = "company" } = imageData
    let addLogoUrl = `https://d1dcu9ldna0u98.cloudfront.net/assets/images/builder/logo/${type === "college" ? 'college' : 'company'}_default_logo.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAUS3ICBEWPOREAJZJ%2F20250401%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250401T064806Z&X-Amz-Expires=300&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEE8aCXVzLWVhc3QtMSJIMEYCIQCTRAkUAOzCgJFVu6DJmktkuzidW5AxBfS3DYL90Ij45QIhAPxsLxo1jiiwBcHmt7%2Bh8QRQSi00t%2B0%2Bl4qr%2FC%2BPxsk5KowDCLj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMMzE1MzYxNDYyNTcyIgyglRb0ifR5SD9sJmcq4ALvSKjUEVknjRU99iWe9g1TcPlEjTc%2Fnglt1b57e9AYm0pzkcWNVGyVN6Ja%2BVOfyG5%2BMMNx88ayA5TvNCTb0rP0lIM%2FEF%2F8JvTVW1FzshHB7ahjXHmXZK79UImwemaMfFR7GjHjxoDhMJdU7duniHkXq9zD9CCS%2B4aP42f8doQUpXu%2FWyCwgq414PEigtWOaX%2FpcoVJFqnAfeAXmaNZzTvc4Ubvd5bI0hAMy%2BFhPyf2meerZYOSJloiKBGinMlNS%2FRI7oRnIU5BnlwKuVu%2Fum7kt42HNAH%2B%2BIAxcF3iCKNPtwZyAJBuCzj%2Fw23zRL1EhA3ygvqCHW7UwjeqG8JU6y4r%2FekP%2F62NCOABFCAa0U%2Fycm%2FhuKAvCnd0f42DBsPEIdWFeSjCxaTkybNCKiaEDMOZvFh%2FhZ36NeeTVuH%2FnPPpfbvxYpXVgfipT%2F0oXNSH65l3Rro03d2mhO9JVHDArEQXMMqXrr8GOrICbRmPKAOGTT47%2BEs%2FWg%2BJq97SANGLdtGNul1Y8DRExI%2BQ9oS7T%2By5Ymx3ewY1Aw98UaD9JGdVL1BuiXUjwEXc%2BAAQP%2FJlOcFk3EfxkmFhu9JBPyqwLw%2BGQ4Uo2TZCBqQg7RL792ig4F77GBvyrtbMX%2Be8luwyZ%2B9xhn7wJltgpDeTR%2FNKpEY0%2Bq92vwgKUx2Aw9WcPhEPYr%2BjAab1Kk7X94EGNGJAlZ889IPGhVRL22eHInDVBsSvbEJUry%2B3NEc9zNwuxoYO3zb6SSF9NXd11hq5MZeGVi5%2BcF0rxpXe57a7oi5i181WvasjKzKZHMSMv6zyFCB4fpkmMcorYkNouwHdZXrySo8jd2e9MnkObmqgoazGQ57KHzn9k%2FN27dLoHBOIpKuk3ep4mTvj%2FnTTsLaS&X-Amz-Signature=83d37b7e8671d2b39e924b4ebf6caca4fe87dc7c2e8c57db1e2b43790cd13eb7&X-Amz-SignedHeaders=host&response-content-disposition=inline`
    let imageDiv = (
      <div className="user-image-container">
        {uploading || url ? (
          <img
            src={uploading ? this.state.croppedImg : url}
            style={{ opacity: uploading ? 0.8 : 1 }}
          />
        ) : null}
        {!uploading && url ? (
          <div className="btn-container">
            <div className="div-background" />
            <div className="button-div change-btn"
              tabIndex={0}
              onClick={this.handleClick}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  this.handleClick(e)
                }
              }
              }
              role="button"
              aria-label="edit logo">
              <img src="dist/images/edit-logo.svg" alt="edit logo" />
            </div>
            <div
              className="remove-btn"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  this.setState({ showDeleteModal: true })
                }
              }
              }
              role="button"
              aria-label="delete logo"
              onClick={() => {
                this.setState({ showDeleteModal: true })
              }}
            >
              <img src="dist/images/delete-icon.svg" alt="delete icon" />
            </div>
          </div>
        ) : null}
        {!uploading && !url ? (
          <div
            aria-label="click to upload"
            className="button-div upload-btn-container"
            onClick={this.handleClick}
          >
            <img
              className="add-logo-icon"
              src={addLogoUrl}
              alt="add logo icon"
            />
            <button className="upload-btn"> +Add Logo</button>
          </div>
        ) : null}
        {uploading ? <div className="three-bar-loader" /> : null}
      </div>
    )
    return (
      <div className="user-logos">
        <form
          className="upload-form"
          method="post"
          ref={(c) => (this.form = c)}
        >
          <input
            aria-label="Upload profile pic"
            type="file"
            name="profile_pic"
            accept="image/*"
            className="sr-only"
            ref={(c) => (this.formPhoto = c)}
            onChange={this.handleFile}
            tabIndex={-1}
          />
          {imageDiv}
          {this.state.cropperOpen && (
            <ImageEditor
              img={this.state.img}
              isOpen={this.state.cropperOpen}
              onRequestHide={this.handleRequestHide}
              onCrop={this.handleCrop}
              company={company}
            />
          )}
          <Modal
            className="logo-delete-modal"
            isOpen={showDeleteModal}
            onRequestHide={() => this.closeDeleteModal()}
          >
            <ModalBody>
              <div>
                <img
                  src="dist/images/delete-skill-icon.svg"
                  alt="delete logo icon"
                />
                <div className="title">Are you Sure?</div>
                <div className="description">
                  Are you sure you want to delete {company} logo?
                </div>
                <div className="btn-container">
                  <button
                    className="cancel-btn"
                    onClick={() => this.closeDeleteModal()}
                  >
                    Cancel
                  </button>
                  <button
                    className="delete-logo-btn"
                    onClick={() => this.deleteLogo(company)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </ModalBody>
          </Modal>
        </form>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    authToken: state.authToken,
  }
}

export default connect(mapStateToProps, {
  updateLogo,
  deleteCompanyLogo,
})(ImageUploader)
